import { QueryClient } from "@tanstack/react-query";

// Lives outside App.tsx on purpose. Components import this directly for cache
// invalidation; when it was exported from App.tsx, ~30 of them pulled the whole
// app root -- router, Keycloak, socket.io, every page -- into their own test
// import graph, and created a cycle (App -> PublicApp -> App).
export const DCSQueryClient = new QueryClient();
